export default "__VITE_ASSET__B3etZ0IS__"